/**
 * Onboarding Guard Component
 *
 * Protects routes that require completed onboarding
 * Redirects to onboarding page if not complete
 */

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

interface OnboardingGuardProps {
  children: React.ReactNode;
  redirectTo?: string;
}

export const OnboardingGuard: React.FC<OnboardingGuardProps> = ({
  children,
  redirectTo = "/onboarding",
}) => {
  const { user } = useAuth();
  const location = useLocation();

  // Check if tenant onboarding is completed from login response
  // Default to true if not present to avoid blocking users
  const isOnboardingComplete = user?.tenantOnboardingCompleted ?? true;

  // Redirect to onboarding if not complete
  if (!isOnboardingComplete) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // Render protected content
  return <>{children}</>;
};

export default OnboardingGuard;
